'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Message = require('../types/message');

var Wantlist = require('../types/wantlist');

var CONSTANTS = require('../constants');

var MsgQueue = require('./msg-queue');

var logger = require('../utils').logger;

module.exports = /*#__PURE__*/function () {
  function WantManager(peerId, network, stats) {
    _classCallCheck(this, WantManager);

    this.peers = new Map();
    this.wantlist = new Wantlist(stats);
    this.network = network;
    this._stats = stats;
    this._peerId = peerId;
    this._log = logger(peerId, 'want');
  }

  _createClass(WantManager, [{
    key: "_addEntries",
    value: function _addEntries(cids, cancel, force) {
      var _this = this;

      var entries = cids.map(function (cid, i) {
        return new Message.Entry(cid, CONSTANTS.kMaxPriority - i, cancel);
      });
      entries.forEach(function (e) {
        // add changes to our wantlist
        if (e.cancel) {
          if (force) {
            _this.wantlist.removeForce(e.cid);
          } else {
            _this.wantlist.remove(e.cid);
          }
        } else {
          _this._log('adding to wl');

          _this.wantlist.add(e.cid, e.priority);
        }
      }); // broadcast changes

      var _iterator = _createForOfIteratorHelper(this.peers.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          p.addEntries(entries);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_startPeerHandler",
    value: function _startPeerHandler(peerId) {
      var mq = this.peers.get(peerId.toB58String());

      if (mq) {
        mq.refcnt++;
        return;
      }

      mq = new MsgQueue(this._peerId, peerId, this.network); // new peer, give them the full wantlist

      var fullwantlist = new Message(true);

      var _iterator2 = _createForOfIteratorHelper(this.wantlist.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;
          fullwantlist.addEntry(entry[1].cid, entry[1].priority);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      mq.addMessage(fullwantlist);
      this.peers.set(peerId.toB58String(), mq);
      return mq;
    }
  }, {
    key: "_stopPeerHandler",
    value: function _stopPeerHandler(peerId) {
      var mq = this.peers.get(peerId.toB58String());

      if (!mq) {
        return;
      }

      mq.refcnt--;

      if (mq.refcnt > 0) {
        return;
      }

      this.peers.delete(peerId.toB58String());
    } // add all the cids to the wantlist

  }, {
    key: "wantBlocks",
    value: function wantBlocks(cids) {
      this._addEntries(cids, false);
    } // remove blocks of all the given keys without respecting refcounts

  }, {
    key: "unwantBlocks",
    value: function unwantBlocks(cids) {
      this._log('unwant blocks: %s', cids.length);

      this._addEntries(cids, true, true);
    } // cancel wanting all of the given keys

  }, {
    key: "cancelWants",
    value: function cancelWants(cids) {
      this._log('cancel wants: %s', cids.length);

      this._addEntries(cids, true);
    } // Returns a list of all currently connected peers

  }, {
    key: "connectedPeers",
    value: function connectedPeers() {
      return Array.from(this.peers.keys());
    }
  }, {
    key: "connected",
    value: function connected(peerId) {
      this._startPeerHandler(peerId);
    }
  }, {
    key: "disconnected",
    value: function disconnected(peerId) {
      this._stopPeerHandler(peerId);
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;

      // resend entire wantlist every so often
      this.timer = setInterval(function () {
        _this2._log('resend full-wantlist');

        var fullwantlist = new Message(true);

        _this2.wantlist.forEach(function (entry) {
          fullwantlist.addEntry(entry.cid, entry.priority);
        });

        _this2.peers.forEach(function (p) {
          return p.addMessage(fullwantlist);
        });
      }, 60 * 1000);
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this3 = this;

      this.peers.forEach(function (mq) {
        return _this3.disconnected(mq.peerId);
      });
      clearInterval(this.timer);
    }
  }]);

  return WantManager;
}();